import React, {useEffect, useState} from "react";
import {StatsDesc, StatsNumber, StatsText} from "../StatisticsBlock/StatisticsBlock.styles";
import {fetchData} from "../../../helpers/fetchData";
import LoadingSpinner from "../../../components/spinners/LoadingSpinner";

const StatisticsWebsite = () => {

    const [stats, setStats] = useState({});
    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {
        fetchData('web-stats')
            .then((res) => setStats(res))
            .then(() => setIsFetching(false))
            .catch((e) => console.error(e));
    }, []);

    return (
        <>
            {
                isFetching ? <LoadingSpinner/> :
                    <>
                        <StatsNumber>{stats.visitors ?? 0}</StatsNumber>
                        <StatsDesc color={'#9ec400'}>{'ODWIEDZIN'}</StatsDesc>
                        <StatsText>{'Tylu fanów odwiedziło naszą stronę internetową.'}</StatsText>
                    </>
            }
        </>
    )
};

export default StatisticsWebsite;
